import { useDataValue } from 'Simple/Data.js'
import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let tab = useDataValue({
    context: 'tab',
    path: 'selected.statements.new',
    viewPath: props.viewPath,
  })

  return useMemo(() => tab || data, [])
}
